var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailNofill = function SvgEmailNofill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    fill: "none",
    viewBox: "0 0 20 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 3.125A2.37 2.37 0 0 1 2.875.75h14.25A2.39 2.39 0 0 1 19.5 3.125v9.5A2.37 2.37 0 0 1 17.125 15H2.875A2.345 2.345 0 0 1 .5 12.625zm1.781 0v.854L8.664 9.21c.78.63 1.856.63 2.635 0l6.42-5.232v-.854c0-.297-.297-.594-.594-.594H2.875a.61.61 0 0 0-.594.594m0 3.154v6.346c0 .334.26.594.594.594h14.25a.61.61 0 0 0 .594-.594V6.279l-5.27 4.305a3.864 3.864 0 0 1-4.935 0z"
  })));
};
export default SvgEmailNofill;